import {vars} from "@/shared/lib/theme.css";
import {ReactNode} from "@tanstack/react-router";
import {HTMLAttributes} from "react";
import {TypographyVariants, typography} from "./index.css";

export type TypographyProps = {children: ReactNode | ReactNode[]; size?: string} & HTMLAttributes<HTMLSpanElement> &
	TypographyVariants;

function Typography({fullWidth, size = vars.size[12], children, fontWeight, style, inline, ...rest}: TypographyProps) {
	return inline ? (
		<span
			className={typography({fullWidth, inline})}
			style={{fontSize: size, fontWeight: fontWeight, ...style}}
			{...rest}
		>
			{children}
		</span>
	) : (
		<p className={typography({fullWidth, inline})} style={{fontSize: size, fontWeight: fontWeight, ...style}} {...rest}>
			{children}
		</p>
	);
}

export default Typography;
